import React from "react";
import { Card, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { postNavigate } from "../../../utils/utils";
import quickbooksConnectIcon from "../../../icons/C2QB_green_btn_med_default.svg";

const INTEGRATION_QUICKBOOKS_URL = `${process.env.NODE_ENV === "production" ? "" : "http://localhost:8080"}/api/v1/protected/auth/intuit`;

const INTEGRATIONS = {
  quickbooks: {
    scope: "intuit.quickbooks.accounting",
    url: INTEGRATION_QUICKBOOKS_URL,
  },
};

// Caller passes `next` starting with `&`; with `?token=` removed, the first
// param needs `?` instead.
export const goToQuickbooks = (next: string) =>
  postNavigate(`${INTEGRATIONS.quickbooks.url}${next.replace(/^&/, "?")}`);

const navigate = () => {
  const next = `&next=${encodeURIComponent(`/manageIntegrations`)}`;
  goToQuickbooks(next);
};

const QuickBooksAddNewCompany = () => (
  <Container className="my-4" style={{ maxWidth: 720 }}>
    <h1 className="h2 mb-2">Add QuickBooks company</h1>
    <p className="text-muted mb-4">
      Connect a QuickBooks Online company to push extracted invoice and bank
      data directly into QBO. You'll authorize DocuClipper through Intuit's
      OAuth flow. We don't see or store your QuickBooks password.
    </p>

    <Card className="shadow-sm mb-4">
      <Card.Body className="text-center py-4">
        <div
          className="btn--add-quickbooks d-inline-block"
          onClick={navigate}
          style={{ cursor: "pointer" }}
        >
          <img
            style={{ height: "44px" }}
            src={quickbooksConnectIcon}
            alt="Connect to QuickBooks"
          />
        </div>
        <div className="small text-muted mt-2">
          Opens Intuit's secure sign-in. You'll be redirected back here when
          done.
        </div>
      </Card.Body>
    </Card>

    <Card className="shadow-sm">
      <Card.Body>
        <h5 className="mb-3">What you can do once connected</h5>
        <ul className="list-unstyled mb-0">
          <li className="mb-2 d-flex">
            <FontAwesomeIcon
              icon="check"
              className="text-success mr-2 mt-1"
              fixedWidth
            />
            <span>Push extracted invoices and bills straight into QBO.</span>
          </li>
          <li className="mb-2 d-flex">
            <FontAwesomeIcon
              icon="check"
              className="text-success mr-2 mt-1"
              fixedWidth
            />
            <span>
              Map vendors and accounts so transactions land in the right place.
            </span>
          </li>
          <li className="d-flex">
            <FontAwesomeIcon
              icon="check"
              className="text-success mr-2 mt-1"
              fixedWidth
            />
            <span>
              Match bank statement transactions to existing QBO records.
            </span>
          </li>
        </ul>
      </Card.Body>
    </Card>
  </Container>
);
export default QuickBooksAddNewCompany;
